define([
  "marionette",
  "messaging/messenger",
  "./standardResponseHeaderView",
  "../standardResponsePublishModal/standardResponsePublishModalModule",
  "modules/header/kbMenu/kbMenuModel",
], function (
  Marionette,
  Messenger,
  StandardResponseHeaderView,
  StandardResponsePublishModalModule,
  KbMenuModel,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "standardResponseHeader";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (standardResponse) {
      this.standardResponse = standardResponse;
      standardResponse.VERSIONED_PENDING_RESPONSE = KbMenuModel.statuses.VERSIONED_PENDING_RESPONSE;
      standardResponse.allowEditTopicStatus = Messenger.reqres.request("can:edit:topicStatus");

      this.view = new StandardResponseHeaderView.view({
        model: standardResponse,
      });
      //mark the standard response to be published
      this.view.on(
        "publishAll",
        function () {
          Messenger.yesNoDialog(
            "topic.dialog.publishAll",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Publish Standard Responses",
                  object: "Standard Response",
                });
                const oldStatusId = standardResponse.get("statusId");
                standardResponse.set("statusId", KbMenuModel.statuses.VERSIONED_PUBLISHED);
                const liveConversation = standardResponse.liveResponse;
                liveConversation.publishAll = true;
                liveConversation.needToPublish = true;
                //save the response
                Messenger.save(function (success) {
                  if (!success) {
                    standardResponse.set("statusId", oldStatusId);
                  }
                  Messenger.vent.trigger("published:responses:locale:dropdown:refresh");
                  this.view.render();
                }, this);
              },
              no: function () {
                Messenger.vent.trigger("standardResponses:cancel:pending:responses");
              },
            },
            this,
          );
        },
        this,
      );
      this.view.on("publishSelected", function () {
        Messenger.vent.trigger(
          "show:modal",
          StandardResponsePublishModalModule,
          {},
          standardResponse,
          {
            title: "topic.publish.title",
            closeOnBackgroundClick: false,
            modalWidth: 550,
            trackInteraction: {
              action: "Publish Standard Responses",
              object: "Standard Response",
            },
          },
        );
      });
      this.showRegion(this.view, { loading: true, entity: standardResponse });
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "standardResponses:cancel:pending:responses",
        function () {
          //if the user cancels the publish pending responses modal, close the topic status drop-down
          this.view.render();
        },
        this,
      );
      Messenger.vent.on(
        "standardResponses:cancel:disable:responses",
        function () {
          //if the user cancels the disable responses modal, close the topic status drop-down
          this.view.render();
        },
        this,
      );
      Messenger.vent.on(
        "standardResponses:publish:pending:responses",
        function () {
          const oldStatusId = this.standardResponse.get("statusId");
          this.standardResponse.liveResponse.needToPublish = true;
          Messenger.save(function (success) {
            if (!success) {
              this.standardResponse.set("statusId", oldStatusId);
            }
            this.view.render();
          }, this);
        },
        this,
      );
      Messenger.vent.on(
        "topic:response:changed",
        function () {
          if (this.isOpen) {
            //when response versioning is enabled and the current status is 'published', then change to 'pending-response'
            const kb = Messenger.reqres.request("active:kb:model");
            kb.onSynced(function () {
              if (kb.get("responseVersioning")) {
                this.standardResponse.set(
                  "statusId",
                  KbMenuModel.statuses.VERSIONED_PENDING_RESPONSE,
                );
                this.view.render();
              }
            }, this);
          }
        },
        this,
      );
    },
  });
});
